import { gql } from '@apollo/client'
import {
  SESSION_REVIEW_FIELDS_FRAGMENT,
  SESSION_REVIEW_SUMMARY_FIELDS_FRAGMENT,
} from '@src/gql/fragments/SessionReviewFragments'

/** Public reviews + summary for one member (guest-readable when the profile is viewable). */
export const USER_SESSION_REVIEWS = gql`
  query UserSessionReviews($userId: String!, $page: Int, $pageSize: Int) {
    userById(userId: $userId) {
      id
      userId
      sessionReviewSummary {
        ...SessionReviewSummaryFields
      }
      sessionReviews(page: $page, pageSize: $pageSize) {
        pagination {
          hasNextPage
          itemCount
          page
          pageSize
        }
        items {
          ...SessionReviewFields
        }
      }
    }
  }
  ${SESSION_REVIEW_FIELDS_FRAGMENT}
  ${SESSION_REVIEW_SUMMARY_FIELDS_FRAGMENT}
`

/** Own summary + linked accounts: drives the hub Reviews tab and the Sync from Clarity button. */
export const OWN_SESSION_REVIEW_SUMMARY = gql`
  query OwnSessionReviewSummary {
    currentUser {
      id
      userId
      sessionReviewSummary {
        ...SessionReviewSummaryFields
      }
      linkedAccounts {
        id
        app
      }
    }
  }
  ${SESSION_REVIEW_SUMMARY_FIELDS_FRAGMENT}
`

/**
 * Manage view (reviewee only): hidden reviews included, hidden text included. Run with
 * `fetchPolicy: 'no-cache'` so manage-only text never lands on the normalized public entity.
 */
export const OWN_SESSION_REVIEWS_MANAGE = gql`
  query OwnSessionReviewsManage($page: Int, $pageSize: Int) {
    currentUser {
      id
      userId
      sessionReviews(page: $page, pageSize: $pageSize, includeHidden: true) {
        pagination {
          hasNextPage
          itemCount
          page
          pageSize
        }
        items {
          ...SessionReviewFields
          isHidden
          isHiddenByAdmin
        }
      }
    }
  }
  ${SESSION_REVIEW_FIELDS_FRAGMENT}
`
